/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _set from "lodash/set";

const initialState = {
  generalInformation: {},
  postalAddress: {},
  electronicAddress: {},
  residentialAddressDetails: {},
  fileUploads: {},
  updateUserStatus: {
    status: "idle",
    error: false,
    loaded: false,
  },
};

const profileUpdateSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateProfileState: (state, action) => {
      return { ...state, ...action.payload };
    },
    updateProfileNestedField: (
      state,
      { payload: { newNestedField, updateEffectPath } }
    ) => {
      return _set(state, updateEffectPath.split(".").slice(1), newNestedField);
    },
    reset: (state) => {
      return initialState;
    },
  },

});

export const { updateProfileState, updateProfileNestedField, reset } =
  profileUpdateSlice.actions;
const { reducer } = profileUpdateSlice;

export default reducer;
